import { cn } from "@/lib/utils";
import Link from "next/link";

type WebsiteUrlLinkProps = {
	url: string;
	className?: string;
};

const regex = /^https?:\/\/(www\.)?/;

export const WebsiteUrlLink = ({ url, className }: WebsiteUrlLinkProps) => {
	const displayUrl = url.replace(regex, "");

	return (
		<Link
			href={url}
			target="_blank"
			rel="noopener noreferrer"
			className={cn(
				"-translate-y-1 absolute top-2 right-2 flex items-center gap-1 rounded-full border border-neutral-200 bg-white py-1 pr-2.5 pl-3 font-medium text-neutral-500 text-xs opacity-0 transition-[opacity,transform] focus-visible:translate-y-0 focus-visible:opacity-100 group-hover:translate-y-0 group-hover:opacity-100",
				className,
			)}
		>
			{displayUrl}
			<div className="rounded-full bg-neutral-100 p-px">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
					className="lucide lucide-arrow-up-right size-2.5"
				>
					<path d="M7 7h10v10" />
					<path d="M7 17 17 7" />
				</svg>
			</div>
		</Link>
	);
};

export default WebsiteUrlLink;
